<template>
  <v-card flat rounded="md" color="grey lighten-2">
    <v-card-text>
      <v-row dense v-if="pedido.obs != ''">
        <v-col cols="12">
          <v-card flat rounded="lg">
            <v-card-subtitle class="font-weight-bold caption pb-1 pt-2"
              >Observação</v-card-subtitle
            >
            <v-card-text class="pb-2">
              {{ pedido.obs }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense class="mt-1">
        <card-info-detalhes-pedido
          title="Data Entrega"
          :info="formatarData(pedido.dtentrega)"
        />
        <card-info-detalhes-pedido title="Conta" :info="pedido.ctacorrente" />
        <card-info-detalhes-pedido
          title="Pagamento"
          :info="pedido.formapgto + '-' + pedido.pgto"
        />
        <card-info-detalhes-pedido title="Usuário" :info="pedido.usuario" />
      </v-row>
      <v-data-table
        :items="pedido.itens"
        :headers="headersItens"
        hide-default-footer
        class="mt-3"
        :disable-sort="isMobile()"
      >
        <template v-slot:[`item.valorunitario`]="{ item }">
          {{ formatarMoeda(item.valorunitario, 4) }}
        </template>
        <template v-slot:[`item.totalitem`]="{ item }">
          {{ formatarMoeda(item.totalitem) }}
        </template>
        <template v-slot:[`item.valoratendido`]="{ item }">
          {{ formatarMoeda(item.valoratendido) }}
        </template>
        <template v-slot:[`item.vlrdesconto`]="{ item }">
          {{ formatarMoeda(item.vlrdesconto) }}
        </template>
        <template v-slot:[`item.percdesconto`]="{ item }">
          {{ formatarPercentual(item.percdesconto) }}
        </template>
        <template v-slot:[`item.perccomissao`]="{ item }">
          {{ formatarPercentual(item.perccomissao) }}
        </template>
      </v-data-table>

      <v-row class="mt-2" dense>
        <v-col cols="12" v-if="pedido.notasfiscais.length > 0">
          <v-card flat>
            <v-card-subtitle class="caption">Notas fiscais</v-card-subtitle>
            <v-card-text>
              <v-data-table
                dense
                no-data-text="Nenhuma nota fiscal encontrada"
                :headers="headersNf"
                :items="pedido.notasfiscais"
                hide-default-footer
                :disable-sort="isMobile()"
              >
                <template v-slot:[`item.valornf`]="{ item }">
                  {{ formatarMoeda(item.valornf) }}
                </template>
                <template v-slot:[`item.datanf`]="{ item }">
                  {{ formatarData(item.datanf) }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <btn-imprimir-nota-fiscal :nf="item" />
                  <btn-imprimir-xml :nf="item" class="ml-2" />
                  <btn-imprimir-boleto class="ml-2" :nf="item" />
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-0" v-if="pedido.status == 6">
        <v-col cols="12">
          <v-alert type="error" text class="body-2 mb-0" dense>{{
            pedido.obsexclusao
          }}</v-alert>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatMoeda, formatPercentual } from "@/global";
import moment from "moment";
import CardInfoDetalhesPedido from "./CardInfoDetalhesPedido.vue";
import BtnImprimirNotaFiscal from "./BtnImprimirNotaFiscal.vue";
import BtnImprimirXml from "./BtnImprimirXml.vue";
import BtnImprimirBoleto from "./BtnImprimirBoleto.vue";

export default {
  components: {
    CardInfoDetalhesPedido,
    BtnImprimirNotaFiscal,
    BtnImprimirXml,
    BtnImprimirBoleto,
  },
  props: {
    pedido: Object,
  },
  data: () => ({
    headersItens: [
      { text: "Produto", value: "nomeitem" },
      { text: "Emb", value: "embalagem" },
      //{ text: "Saldo", value: "saldo" },
      { text: "Qtde Pedida", value: "qtdepedida" },
      { text: "Valor Unitário", value: "valorunitario" },
      { text: "Total item", value: "totalitem" },
      { text: "Qtde Atendida", value: "qtdeatendida" },
      //{ text: "Qtde Origem", value: "qtdeorigem" },
      { text: "Valor Atendido", value: "valoratendido" },
      { text: "Valor Desconto", value: "vlrdesconto" },
      { text: "% Desc", value: "percdesconto" },
      { text: "% Comissão", value: "perccomissao" },
    ],
    headersNf: [
      { text: "Filial", value: "filial" },
      { text: "Nota", value: "nota" },
      { text: "Data", value: "datanf" },
      { text: "Valor", value: "valornf" },
      { text: "", value: "actions", sortable: false, align: "end" },
    ],
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    formatarMoeda(value, cd = 2) {
      return formatMoeda(value, cd);
    },
    formatarData(value) {
      if (value == "" || value == null) return "";
      return moment(value).format("DD/MM/YYYY");
    },
    formatarPercentual(value) {
      /*return parseFloat(value).toLocaleString({
        style: "percent",
        minimumFractionDigits: 2,
      });*/
      return formatPercentual(value);
    },
  },
};
</script>

<style>
</style>